import Heading from '../../../../components/Heading/Heading';
import styles from './CreateUser.module.css';
import infoIcon from '../../../../assets/img/info.svg';
import { Tooltip } from 'primereact/tooltip';
import Icon from '../../../../components/Icon/Icon';
import { InputText } from 'primereact/inputtext';
import { useFormik } from 'formik';
import Error from '../../../../components/Error/Error';
import CONSTANTS from '../../../../constants';
import { Dropdown } from 'primereact/dropdown';
import Toggle from '../../../../components/Toggle/Toggle';
import { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { createUserSchema } from '../../../../schemas';
import {
	generateApprovedUserRoles,
	modifyApprovedUser,
	submitNewUser,
} from '../../../../utils/common.utils';
import { Divider } from 'primereact/divider';

const CreateUser = (props) => {
	const { isEditable, userId } = props;
	const {
		values,
		touched,
		errors,
		handleBlur,
		handleChange,
		handleSubmit,
		setFieldValue,
	} = useFormik({
		initialValues: CONSTANTS.initialCreateUserValue,
		validationSchema: createUserSchema,
		onSubmit: (values, action) => {
			// console.log(values);
			isEditable ? modifyApprovedUser(values) : submitNewUser(values);
			action.resetForm();
		},
	});

	const [showDetails, setShowDetails] = useState(false);
	const [approvedUserRoleList, setApprovedUserRoleList] = useState([]);

	useEffect(() => {
		generateApprovedUserRoles(setApprovedUserRoleList);
		setFieldValue('userId', userId);
	}, [setFieldValue, userId]);

	const rolesList = approvedUserRoleList?.map((roleObj) => roleObj.roleName);
	const selectedRoleObj = approvedUserRoleList?.find(
		roleObj => roleObj.roleName === values.userRole
	);	
	const rolePermissionGroup = selectedRoleObj?.permissionGroups;

	return (
		<div className={isEditable ? '' : 'main'}>
			{isEditable ? '' : <Heading>Create User</Heading>}
			<form
				className={`${styles['create-user__container']} ${styles.card}`}
				onSubmit={handleSubmit}
			>
				<div className={styles.card}>
					<h3>User Details</h3>
					<div className={styles.form}>
						{/* User ID */}
						<div className={styles['input__container']}>
							<div className={styles['label__container']}>
								<label htmlFor="userId" className={styles['input-label']}>
									User ID:
								</label>
								<img
									src={infoIcon}
									className={`${styles.info} userId-tooltip`}
									alt="tooltip"
									data-pr-tooltip="Enter your user ID to create the user."
								/>
							</div>
							<Tooltip target=".userId-tooltip" className={styles.tooltip} />
							<div className="p-inputgroup">
								<Icon icon="fingerprint" className="p-inputgroup-addon" />
								<InputText
									className={`${
										touched.userId && errors.userId ? 'p-invalid' : ''
									} styles.input`}
									id="userId"
									name="userId"
									disabled={isEditable}
									placeholder="Enter your user ID"
									value={values.userId}
									onChange={handleChange}
									onBlur={handleBlur}
								/>
							</div>
							{touched.userId && errors.userId ? (
								<Error>{errors.userId}</Error>
							) : null}
						</div>
						{/* User Name */}
						<div className={styles['input__container']}>
							<div className={styles['label__container']}>
								<label htmlFor="userName" className={styles['input-label']}>
									User name:
								</label>
								<img
									src={infoIcon}
									className={`${styles.info} userName-tooltip`}
									alt="tooltip"
									data-pr-tooltip="Enter your user name to create the user."
								/>
							</div>
							<Tooltip target=".userName-tooltip" className={styles.tooltip} />
							<div className="p-inputgroup">
								<Icon icon="badge" className="p-inputgroup-addon" />
								<InputText
									className={`${
										touched.userName && errors.userName ? 'p-invalid' : ''
									} styles.input`}
									id="userName"
									name="userName"
									placeholder="Enter your user name"
									value={values.userName}
									onChange={handleChange}
									onBlur={handleBlur}
								/>
							</div>
							{touched.userName && errors.userName ? (
								<Error>{errors.userName}</Error>
							) : null}
						</div>
						{/* Password */}
						<div className={styles['input__container']}>
							<div className={styles['label__container']}>
								<label htmlFor="password" className={styles['input-label']}>
									Password:
								</label>
								<img
									src={infoIcon}
									className={`${styles.info} password-tooltip`}
									alt="tooltip"
									data-pr-tooltip="Enter your password to create the user."
								/>
							</div>
							<Tooltip target=".password-tooltip" className={styles.tooltip} />
							<div className="p-inputgroup">
								<Icon icon="password" className="p-inputgroup-addon" />
								<InputText
									className={`${
										touched.password && errors.password ? 'p-invalid' : ''
									} styles.input`}
									type="password"
									id="password"
									name="password"
									placeholder="Enter your password"
									value={values.password}
									onChange={handleChange}
									onBlur={handleBlur}
								/>
							</div>
							{touched.password && errors.password ? (
								<Error>{errors.password}</Error>
							) : null}
						</div>
						{/* Confirm Password */}
						<div className={styles['input__container']}>
							<div className={styles['label__container']}>
								<label
									htmlFor="confirmPassword"
									className={styles['input-label']}
								>
									Confirm password:
								</label>
							</div>

							<div className="p-inputgroup">
								<Icon icon="password" className="p-inputgroup-addon" />
								<InputText
									className={`${
										touched.confirmPassword && errors.confirmPassword
											? 'p-invalid'
											: ''
									} styles.input`}
									type="password"
									id="confirmPassword"
									name="confirmPassword"
									placeholder="Re-enter your password"
									value={values.confirmPassword}
									onChange={handleChange}
									onBlur={handleBlur}
								/>
							</div>
							{touched.confirmPassword && errors.confirmPassword ? (
								<Error>{errors.confirmPassword}</Error>
							) : null}
						</div>
						{/* User Role */}
						<div className={styles['input__container']}>
							<div className={styles['label__container']}>
								<label htmlFor="userRole" className={styles['input-label']}>
									User role:
								</label>
								<img
									src={infoIcon}
									className={`${styles.info} userRole-tooltip`}
									alt="tooltip"
									data-pr-tooltip="Enter the role of the user."
								/>
							</div>
							<Tooltip target=".userRole-tooltip" className={styles.tooltip} />
							<div className="p-inputgroup">
								<Icon icon="password" className="p-inputgroup-addon" />
								<Dropdown
									inputId="userRole"
									name="userRole"
									placeholder="Select a user role"
									value={values.userRole}
									onChange={handleChange}
									onBlur={handleBlur}
									options={rolesList}
								/>
							</div>
							{touched.userRole && errors.userRole ? (
								<Error>{errors.userRole}</Error>
							) : null}
							<Toggle
								checked={showDetails}
								handleChange={() => setShowDetails(!showDetails)}
								className={styles.toggle}
							/>
						</div>

						{/* Toggle */}
						<div className={styles['next-button__container']}>
							<Button className={styles['submit-button__alt']}>
								Submit User Details
							</Button>
						</div>
						<div className={styles.tooltip}>
							Note: Users with role 'admin' and 'channel' cannot be edited or
							deleted from the dashboard once created.
						</div>

						{showDetails ? (
							<div>
								<div className={styles.divider}>
									<h3>Permission Groups for user role {values.userRole}</h3>
									<Divider />
								</div>
								<div className={styles['permission__container']}>
									{rolePermissionGroup?.map((pGroup) => (
										<div key={pGroup.permissionGroup}>
											<div className={styles['group-name']}>
												{pGroup.permissionGroup}
											</div>
											<div>List of APIs</div>
											<div className={styles['api-list']}>
												{pGroup?.groupApis?.map((api) => (
													<div key={api} className={styles.api}>
														{api}
													</div>
												))}
											</div>
										</div>
									))}
								</div>
							</div>
						) : null}
					</div>
				</div>
			</form>
		</div>
	);
};

export default CreateUser;
